import { call, put } from 'redux-saga/effects';
import GetCheckSickNoteActions from '../redux/GetCheckSickNoteRedux';
import { api } from './api';


export function* getchecksicknotesagas(action: any): Generator<any, void, any> {
  const { leave_id } = action;
  const response = yield call(api.getCheckSickNote, leave_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetCheckSickNoteActions.getCheckSickNoteSuccess(response.data));
  } else {
    yield put(GetCheckSickNoteActions.getCheckSickNoteFailure());
  }
}